import { Button } from '@ets-global/b2c-website-ui';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import BaseModal from '../../Base/Modal/BaseModal';

const SessionSwitchWarningModal = ({ message, canValidate, onClose, onSubmit }) => {
  const { t } = useTranslation();
  const buttons = (
    <Fragment>
      <Button name="button" className={'button--transparent-light'} onClick={onClose} aria-label={t('common.cancel')}>
        <Trans>common.cancel</Trans>
      </Button>

      {canValidate && (
        <Button
          name="button"
          onClick={onSubmit}
          data-cypress={'buying-process.accept-change-session'}
          aria-label={t('common.validate')}
        >
          <Trans>common.validate</Trans>
        </Button>
      )}
    </Fragment>
  );

  return (
    <BaseModal
      isOpen
      onClose={onClose}
      title={<Trans>session-search.main.item.warning.change-session.title</Trans>}
      footer={buttons}
    >
      <Trans>{message}</Trans>
    </BaseModal>
  );
};

SessionSwitchWarningModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default SessionSwitchWarningModal;
